module.exports = "<div *ngIf=\"isVisible\">\r\n    <div class=\"loading-container\"></div>\r\n    <span class=\"k-icon k-i-loading\"></span>\r\n</div>"